
class scrollEvent {

    

    constructor() {
        // this is working in progress scrollEvent class.
        // We will add more scroll events in the file
        // that can be shared across the whole site.

        this.easings = {
          linear(t) {
            return t;
          },
          easeInQuad(t) {
            return t * t;
          },
          easeOutQuad(t) {
            return t * (2 - t);
          },
          easeInOutQuad(t) {
            return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
          },
          easeInCubic(t) {
            return t * t * t;
          },
          easeOutCubic(t) {
            return (--t) * t * t + 1;
          },
          easeInOutCubic(t) {
            return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
          },
          easeInQuart(t) {
            return t * t * t * t;
          },
          easeOutQuart(t) {
            return 1 - (--t) * t * t * t;
          },
          easeInOutQuart(t) {
            return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * (--t) * t * t * t;
          },
          easeInQuint(t) {
            return t * t * t * t * t;
          },
          easeOutQuint(t) {
            return 1 + (--t) * t * t * t * t;
          },
          easeInOutQuint(t) {
            return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * (--t) * t * t * t * t;
          }
        };
    }

    //throttle scrolling event to improve performance
    throttle (callback, wait) {
        var time,
            go = true;
        return function() {
            if(go) {
                go = false;
                time = setTimeout(function(){
                    time = null;
                    go = true;
                    callback.call();
                }, wait);
            }
        }
    }

    //debounce scrolling event to improve performance
    debounce (callback, delay) {
        var timeout = null;
        return function() {
            if (timeout) {
                clearTimeout(timeout);
            }
            var args = arguments;
            timeout = setTimeout(function() {
                callback.apply(null, args);
                timeout = null;
            }, delay);
        }
    }
    // https://www.sitepoint.com/javascript-from-scratch/6/
    // NOTE: combination of element and (current) page scroll position
    getScrollPosition(el) {      
      let position = {
        'xPos':0,
        'yPos':0
      };
      if(el) {

        let posX = 0;        
        let posY = 0;        
              
        while (el != null)        
        {        
          posX += el.offsetLeft;        
          posY += el.offsetTop;        
          el = el.offsetParent;        
        }
        position = {
          'xPos':posX,
          'yPos':posY
        }; 
      } else {
        if (typeof window.pageYOffset != 'undefined') {      
          position = {
            'xPos':window.pageXOffset,
            'yPos':window.pageYOffset
          };
        } else if (typeof document.documentElement.scrollTop != 'undefined' && document.documentElement.scrollTop > 0) {      
          position = {
            'xPos':document.documentElement.scrollLeft,
            'yPos':document.documentElement.scrollTop
          };
        } else if (typeof document.body.scrollTop != 'undefined') {      
          position = {
            'xPos':document.body.scrollLeft,
            'yPos':document.body.scrollTop
          };
        } 
        
      }     
          
      return position;      
    }

    /**
     * scrolls a scrollable div to a position specified withith it.  e.g, scrollTop = 100;
     * @param {*} container - main parent scrollable div
     * @param {*} target - target div within parent div
     * @param {*} duration - duration of animation
     * @param {*} easing - easing
     */
    scrollTop(container, target, duration = 300, easing = 'linear') {

      const tick = 10;
      const easings = this.easings;
      let start = container.scrollTop;
      let currentTime = 0;
      let targetOffsetToScroll = target.getBoundingClientRect().top - container.getBoundingClientRect().top;

      if (window.requestAnimationFrame instanceof Function === false) {
        container.scrollTop = targetOffsetToScroll;
        return;
      }

      var scroll = () => {
          currentTime += tick;
          const time = Math.min(1, (currentTime / duration));
          const easingCoefficient = easings[easing](time);
          let travelDistance = Math.ceil((easingCoefficient * targetOffsetToScroll) + start);
          container.scrollTop = travelDistance;

          if (currentTime < duration) {
              window.requestAnimationFrame(scroll);
          }
      }

     scroll();

    }

    scrollTo(destination, offset = 0, duration = 200, easing = 'linear', callback) {

      const easings = this.easings;

      let getCurrentTime = () => {
        return (window.performance.now instanceof Function) ? window.performance.now() : new Date().getTime();        
      };

      const start = window.pageYOffset;
      const startTime = getCurrentTime();

      const documentHeight = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight);
      const windowHeight = window.innerHeight || document.documentElement.clientHeight || document.getElementsByTagName('body')[0].clientHeight;
      const destinationOffset = typeof destination === 'number' ? destination : this.getCoords(destination).top - offset;
      const destinationOffsetToScroll = Math.round(documentHeight - destinationOffset < windowHeight ? documentHeight - windowHeight : destinationOffset);

      if (window.requestAnimationFrame instanceof Function === false) {
        window.scroll(0, destinationOffsetToScroll);
        if (callback) {
          callback();
        }
        return;
      }

      var scroll = () => {
        const now = getCurrentTime();
        const time = Math.min(1, ((now - startTime) / duration));
        const easingCoefficient = easings[easing](time);
        let t = Math.ceil((easingCoefficient * ( destinationOffsetToScroll - start)) + start);
        window.scroll(0, t);

        if (window.pageYOffset === destinationOffsetToScroll) {
          if (callback) {
            callback();
          }
          return;
        }

        requestAnimationFrame(scroll);
      }

      scroll();
    }
    /**
    * returns the proper offset top on an element
    * @return object literal with top and left
    */
    getCoords(elem) { // crossbrowser version
        var box = elem.getBoundingClientRect();

        var body = document.body;
        var docEl = document.documentElement;

        var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
        var scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;

        var clientTop = docEl.clientTop || body.clientTop || 0;
        var clientLeft = docEl.clientLeft || body.clientLeft || 0;

        var top  = box.top +  scrollTop - clientTop;
        var left = box.left + scrollLeft - clientLeft;

        return { top: Math.round(top), left: Math.round(left) };
    }

};

export default new scrollEvent();



// WEBPACK FOOTER //
// ./assets/components/fsUtils/scrollEvent.js